import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class ApprovalGroupService {
  index(payload) {
    let filters = {};
    if (payload.options) {
      filters = { ...filters, ...payload.options };
    }

    if (payload.search) {
      filters = { ...filters, search: payload.search };
    }

    return axios.get(API_URL + "approvals/approval-groups", {
      params: filters,
      headers: authHeader(),
    });
  }
  show(id) {
    return axios.get(API_URL + "approvals/approval-groups/" + id, {
      headers: authHeader(),
    });
  }
  store(item) {
    return axios.post(API_URL + "approvals/approval-groups", item, {
      headers: authHeader(),
    });
  }
  update(item) {
    // Dedicated POST path — avoids PUT 403 on some HTTPD hosts and avoids
    // X-HTTP-Method-Override (blocked by restrictive CORS Allow-Headers).
    return axios.post(
      API_URL + "approvals/approval-groups/" + item.id + "/update",
      item,
      { headers: authHeader() }
    );
  }
  delete(item) {
    return axios.post(
      API_URL + "approvals/approval-groups/" + item.id + "/delete",
      {},
      { headers: authHeader() }
    );
  }
}

export default new ApprovalGroupService();
